import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';
import type { UserRecent } from 'src/hooks/recents';
import { type GetUserRecentsParams, UserRequest } from 'src/requests/user';

export const useUserRecentsPersistance = () => {
  const { mutateAsync: getRecents, isLoading: isGettingRecents } = useMutation(
    (params: GetUserRecentsParams) => UserRequest.getUserRecents(params),
  );

  const getUserRecents = useCallback(
    async (params: GetUserRecentsParams): Promise<UserRecent[]> => {
      return await getRecents(params);
    },
    [getRecents],
  );

  const { mutateAsync: addRecent, isLoading: isAddingRecent } = useMutation(
    (recent: Partial<UserRecent>) => UserRequest.upsertUserRecent(recent),
  );

  const addUserRecent = useCallback(
    async (recent: Partial<UserRecent>): Promise<UserRecent> => {
      return await addRecent(recent);
    },
    [addRecent],
  );

  const { mutateAsync: removeRecent, isLoading: isRemovingRecent } =
    useMutation((id: string) => UserRequest.removeUserRecent(id));

  const removeUserRecent = useCallback(
    async (id: string): Promise<void> => {
      await removeRecent(id);
    },
    [removeRecent],
  );

  return {
    getUserRecents,
    isGettingRecents,
    removeUserRecent,
    isRemovingRecent,
    addUserRecent,
    isAddingRecent,
  };
};
